// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthAuthorizationRequestSchema = z.object({
  client_id: z.coerce.string().min(1).describe("OAuth 2.0 client identifier"),
  redirect_uri: z.coerce.string().min(1).describe("OAuth 2.0 redirect URI"),
  response_type: z.coerce.string().min(1).describe("OAuth 2.0 response type (must be \"code\")"),
  scope: z.coerce.string().describe("OAuth 2.0 requested scope (defaults to \"manage\")").nullish(),
  state: z.coerce.string().describe("OAuth 2.0 state parameter for CSRF protection").nullish(),
});
